import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-legenda-status-documentos',
  templateUrl: './legenda-status-documentos.component.html',
  styleUrls: ['./legenda-status-documentos.component.css']
})
export class LegendaStatusDocumentosComponent implements OnInit {

  constructor() { }

  @Input() tipoVisualizacao = 'legenda'; // legenda-detalhe
  @Input() documento: any = null;
  @Input() propStatus = 'status';
  @Input() propCodigoResposta = 'codigoResposta';
  @Input() propDescricaoResposta = 'descricaoResposta';
  @Input() statusOptions =
    [
      { id: 'A', name: 'Aprovada', },
      { id: 'C', name: 'Cancelada' },
      { id: 'F', name: 'Encerrado' },
      { id: 'I', name: 'Inutilizada' },
      { id: 'U', name: 'Rascunho' },
      { id: 'D', name: 'Denegada' },
      { id: 'R', name: 'Reprovada' },
      { id: '0', name: 'Sem retorno' },
      { id: 'V', name: 'Devolvida' },
      { id: 'E', name: 'Estorno' },
      { id: 'EE', name: 'Estornada' },
      { id: 'N', name: 'Aguardando Ambiente Nacional' },
    ];
  @Input() tipoDocumento: 'NFE' | 'CTE' | 'MDFE' = 'NFE';

  ngOnInit() {
  }

  getColor(status: string) {
    switch (status) {
      case 'A':
        return 'green';
      case 'C':
        return '#448aff';
      case 'F':
        return '#8A2BE2';
      case 'I':
        return 'orange';
      case 'R':
        return '#ff5252';
      case 'D':
        return '#212020';
      case 'U':
        return 'var(--base-text-color)';
      case 'E':
        return '#60A5FA';
      case 'EE':
        return '#F59E0B';
      case 'V':
        return '#60A5FA';
      default:
        return 'silver';
    }
  }

  getIcon(status: string) {
    switch (status) {
      case 'U':
        return 'fa fa-pencil';
      case 'A':
        return 'fa fa-check';
      case 'C':
        return 'fa fa-circle';
      case 'F':
        return 'fa-regular fa-check-circle';
      case 'I':
        return 'fa fa-circle';
      case 'R':
        return 'fa fa-times';
      case 'D':
        return 'fa fa-legal';
      case 'E':
        return 'ti-back-right';
      case 'EE':
        return 'ti-back-left';
      case 'N':
        return 'fa-regular fa-hourglass-half';
      case 'V':
        return 'fa fa-reply';
      default:
        return 'fa fa-circle';
    }
  }

  retornaDescStatusDoc(documento): string {
    switch (documento[this.propStatus]) {
      case 'I':
        return 'Numeração Inutilizada';
      case 'C':
        return this.tipoDocumento === 'CTE' ? 'CT-e Cancelado' : this.tipoDocumento === 'MDFE' ? 'MDF-e Cancelado' : 'Nota Cancelada';
      case 'D':
        return this.tipoDocumento === 'CTE' ? 'CT-e Denegado' : 'Nota Denegada';
      case 'U':
        return 'Rascunho';
      case 'F':
        return 'MDF-e Encerrado';
      case 'E':
        if (documento.notaFiscalEstornada?.numeroNotaFiscal) {
          return `Estorno de ${documento.notaFiscalEstornada?.numeroNotaFiscal}`;
        } else {
          return 'Estorno';
        }
      case 'EE':
        if (documento.notaFiscalEstorno?.numeroNotaFiscal) {
          return `Estornada pela ${documento.notaFiscalEstorno?.numeroNotaFiscal}`;
        } else {
          return 'Estornada';
        }
      case 'N':
        return 'Aguardando validação do ambiente nacional - Aguarde alguns minutos e utilize o botão "Consultar Situação" para atualizar';
      case 'V':
        return 'Devolvida';
    }

    switch (documento[this.propCodigoResposta]) {
      case '100':
        return this.tipoDocumento === 'CTE' ? 'CT-e Aprovado' : this.tipoDocumento === 'MDFE' ? 'MDF-e Aprovado' : 'Nota Aprovada';
      case '999':
        return 'Erro de sistema';
      case '0':
      case '':
      case null:
        return 'Documento não enviado ao SEFAZ';
      default:
        return documento[this.propCodigoResposta] + ' - ' + documento[this.propDescricaoResposta];
    }
  }
}
